import React from 'react'
import { MainBgImage } from '../../common'
import styled from 'styled-components'
import { Row, Col } from 'reactstrap'
import Image from '../../../images/CoachResources/PGA_Event-23.jpg'
import Svg from '../../common/Svg'
import { appleStore, googlePlay } from '../../common/Svg/elements'
import theme from '../../theme'
import { ContainerLg, H2 } from '../../GlobalStyles'
import { TextLink, ScrollLink } from '../../common/Links'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../constants'

export const BackgroundImageWrapper = styled.div`
  .gatsby-image-wrapper {
    height: 100%;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

export const HomeMainImage = () => {
  return (
    <MainBgImage
      height={517}
      position='flex-end'
      imageUrl={Image}
      overlay='rgba(0, 35, 75, 0.4)'
    >
      <BackgroundImageWrapper>
        <ContainerLg>
          <Row>
            <Col lg='6'>
              <H2 marginBottom='32px' textAlign='left'>
                Find the latest ADM approved activities in the PGA COACH App
              </H2>
              <ButtonsContainer>
                <TextLink
                  color={theme.colors.white}
                  hoverColor={theme.colors.lightGray}
                  url={myPgaIOSUrl}
                >
                  <Svg d={appleStore} width={125} height={36} />
                </TextLink>
                <TextLink
                  color={theme.colors.white}
                  hoverColor={theme.colors.lightGray}
                  url={myPgaAndroidUrl}
                >
                  <Svg d={googlePlay} width={125} height={36} />
                </TextLink>
              </ButtonsContainer>
            </Col>
          </Row>
        </ContainerLg>
      </BackgroundImageWrapper>
      <ScrollLink scrollTo='features' />
    </MainBgImage>
  )
}

export default HomeMainImage
